import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c11db398"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "intro remove-mix-blend-mode",
  ref: "pageSection"
}
const _hoisted_2 = {
  class: "intro__section",
  "data-set-background-color": "black"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro__image_container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/NMM-lamp.png",
    class: "intro__image",
    width: "600",
    height: "994"
  })
], -1))
const _hoisted_5 = { class: "intro__text" }
const _hoisted_6 = {
  class: "intro__section",
  "data-set-background-color": "gold"
}
const _hoisted_7 = { class: "container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro__image_container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/NMM-trompet.png",
    class: "intro__image",
    width: "600",
    height: "1718"
  })
], -1))
const _hoisted_9 = { class: "intro__text" }
const _hoisted_10 = {
  class: "intro__section",
  "data-set-background-color": "grey"
}
const _hoisted_11 = { class: "container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro__image_container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/NMM-zuurstof.png",
    class: "intro__image",
    width: "600",
    height: "1148"
  })
], -1))
const _hoisted_13 = { class: "intro__text" }
const _hoisted_14 = {
  class: "intro__section",
  "data-set-background-color": "color"
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro__image_container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/NMM-grafitti.png",
    class: "intro__image",
    width: "600",
    height: "1552"
  })
], -1))
const _hoisted_17 = { class: "intro__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textures = _resolveComponent("Textures")!
  const _component_DisplayType = _resolveComponent("DisplayType")!
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Textures, {
      type: "raw-01",
      class: "intro__texture",
      color: "white",
      "parallax-speed": 5
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_DisplayType, {
          class: "intro__title",
          line1: "Ontdek",
          line1MaskHeight: 100,
          line1Indent: -0.2,
          line2: "zwarte",
          line2MaskHeight: 100,
          line2Indent: 0.3,
          line3: "verhalen",
          line3MaskHeight: 70,
          line3Indent: -0.1,
          animateTitle: false,
          elementType: "h2"
        }, null, 8, ["line1Indent", "line2Indent", "line3Indent"]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", null, null, 512), [
            [_directive_sanitize, _ctx.black]
          ]),
          (_ctx.blacklink)
            ? (_openBlock(), _createBlock(_component_ButtonLink, {
                key: 0,
                class: "intro__button",
                href: _ctx.blacklink.href,
                label: _ctx.blacklink.title,
                color: "white"
              }, null, 8, ["href", "label"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_DisplayType, {
          class: "intro__title",
          line1: "Ontdek",
          line1MaskHeight: 70,
          line1Indent: 0,
          line2: "gouden",
          line2MaskHeight: 100,
          line2Indent: -0.9,
          line3: "tijden",
          line3MaskHeight: 75,
          line3Indent: 0.8,
          animateTitle: false,
          elementType: "h2"
        }, null, 8, ["line2Indent", "line3Indent"]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("div", null, null, 512), [
            [_directive_sanitize, _ctx.gold]
          ]),
          (_ctx.goldlink)
            ? (_openBlock(), _createBlock(_component_ButtonLink, {
                key: 0,
                class: "intro__button",
                href: _ctx.goldlink.href,
                label: _ctx.goldlink.title,
                color: "white"
              }, null, 8, ["href", "label"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_DisplayType, {
          class: "intro__title",
          line1: "Ontdek",
          line1MaskHeight: 100,
          line1Indent: -1,
          line2: "grauwe",
          line2MaskHeight: 100,
          line2Indent: 1,
          line3: "kanten",
          line3MaskHeight: 70,
          line3Indent: -0.2,
          animateTitle: false,
          elementType: "h2"
        }, null, 8, ["line3Indent"]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("div", null, null, 512), [
            [_directive_sanitize, _ctx.grey]
          ]),
          (_ctx.greylink)
            ? (_openBlock(), _createBlock(_component_ButtonLink, {
                key: 0,
                class: "intro__button",
                href: _ctx.greylink.href,
                label: _ctx.greylink.title
              }, null, 8, ["href", "label"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_DisplayType, {
          class: "intro__title",
          line1: "Ontdek",
          line1MaskHeight: 65,
          line1Indent: 0,
          line2: "kleurrijke",
          line2MaskHeight: 100,
          line2Indent: 0,
          line3: "ambities",
          line3MaskHeight: 70,
          line3Indent: 1,
          animateTitle: false,
          elementType: "h2"
        }),
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("div", null, null, 512), [
            [_directive_sanitize, _ctx.color]
          ]),
          (_ctx.colorlink)
            ? (_openBlock(), _createBlock(_component_ButtonLink, {
                key: 0,
                class: "intro__button",
                href: _ctx.colorlink.href,
                label: _ctx.colorlink.title,
                color: "white"
              }, null, 8, ["href", "label"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}